import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import PropTypes from 'prop-types';
import R from 'ramda';
import classNames from 'classnames';

import styles from './cell.css';

const { div } = hh(h);

const Cell = ({
    padding = ['top', 'right', 'bottom', 'left'],
    width = true,
    classes = [],
    ...props
}) => (
    div({
        className: classNames(
            ...classes,
            styles.base,
            R.map((pad) => R.prop(`${pad}Padding`, styles), padding),
            {
                [styles.width]: R.equals(width, true)
            }
        )
    }, props.children)
);

Cell.propTypes = {
    padding: PropTypes.array,
    width: PropTypes.bool,
    classes: PropTypes.array
};

export default Cell;



/** WEBPACK FOOTER **
 ** ./src/Cell/index.js
 **/